// extracted by mini-css-extract-plugin
export default {"notification__text":"Notifications_notification__text__k-lVU"};